import { IControlStyles } from "../layouts";
import { GridActionType } from "../types";
import { VfxLib } from "../vfx";
import { ControlDatagridActionButtonProps } from "../vfx/controls/components/datagrid/controlDataGrid";

export const createLayoutOptions = (hasData: boolean) => ({
  displayPageInfo: hasData,
  displayPageLength: hasData,
  displayPaging: hasData,
});

type Alignment = "left" | "right" | "center";

const normalizeKey = (value: string) => {
  return value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
};

export const createActionColumn = (
  styles: IControlStyles,
  dataId: string,
  buttonKeys: GridActionType[],
  displayIconOnly?: boolean | undefined,
  alignment: Alignment = "right"
) => {
  const allButtons = VfxLib.datagridActionButtons({
    datagridStyles: styles,
    displayIconOnly: displayIconOnly,
  });

  const actionButtons: ControlDatagridActionButtonProps[] = buttonKeys
    .map((key) => {
      const normalizedKey = normalizeKey(key);
      const match = Object.keys(allButtons).find(
        (btnKey) => normalizeKey(btnKey) === normalizedKey
      );
      if (!match) {
        return null;
      }
      return allButtons[match];
    })
    .filter((btn): btn is ControlDatagridActionButtonProps => !!btn);

  return {
    data: dataId,
    title: "Action",
    visible: true,
    columnType: "action" as const,
    alignment: alignment,
    width: "100px",
    controlStyles: styles,
    actionButtons,
  };
};
